import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";

function EarlyLeaveRequest() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [selectedCenterId, setSelectedCenterId] = useState(
    savedCenterId || null
  );
  const [centersData, setCentersData] = useState([]);
  const [earlyLeaveRequestsData, setEarlyLeaveRequestsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {},
  });

  //   useEffect(() => {
  //     const fetchCenters = async () => {
  //       try {
  //         const response = await get(
  //           `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         setCentersData(response);

  //         if (savedCenterId) {
  //           const selectedCenter = response.find(
  //             (center) => center.id === parseInt(savedCenterId, 10)
  //           );

  //           if (selectedCenter) {
  //             setValue("centerId", {
  //               value: selectedCenter.id,
  //               label: selectedCenter.name,
  //             });
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error fetching centers:", error);
  //       }
  //     };

  //     fetchCenters();
  //   }, [selectedCenterId]);

  useEffect(() => {
    const fetchEarlyLeaveRequests = async () => {
      try {
        const response = await get(
          `MobileApp/GetEarlyRequestsByCenterId?centerId=${selectedCenterId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEarlyLeaveRequestsData(response);
      } catch (error) {
        console.error("Error fetching early leave requests:", error);
      }
    };

    if (selectedCenterId) {
      fetchEarlyLeaveRequests();
    }
  }, [selectedCenterId, triggerRerender]);

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Student Name",
      selector: (row) => row.studentName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Student Code",
      selector: (row) => row.studentCode,
      // width: "100px",
    },
    {
      name: "Reason",
      // selector: (row) => row.reason,
      width: "300px",
      selector: (row) => <div title={row.reason}>{row.reason}</div>,
    },
    {
      name: "Request Date",
      selector: (row) => row.requestDate.split("T")[0],
      // width: "100px",
    },
    {
      name: "Leave Time",
      selector: (row) => row.leaveTime.split("T")[0],
      // width: "100px",
    },
    { name: "Status", selector: (row) => row.status },
    {
      name: "Action",
      width: "150px",
      selector: (row) => (
        <>
          <div className="d-flex gap-1">
            <button
              className="btn btn-success px-2 py-1"
              onClick={() => handleApproveRejectBtn(row, "approved")}
              type="button"
            >
              Approve
            </button>
            <button
              className="btn btn-danger px-2 py-1"
              onClick={() => handleApproveRejectBtn(row, "rejected")}
              type="button"
            >
              Reject
            </button>
          </div>
        </>
      ),
    },
  ];

  const handleApproveRejectBtn = async (row, decision) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formData = {
      id: row.studentId,
      status:
        decision === "approved"
          ? "approved"
          : decision === "rejected"
          ? "rejected"
          : "",
      isApproved: decision === "approved",
      approvedBy: localStorage.getItem("userId"),
      approverRemarks: decision,
    };

    try {
      const response = await post(
        "MobileApp/EarlyLeaveRequestsApproveRejectAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success("Success!");
        setTriggerRerender((prev) => !prev);
      } else {
        toast.error(response?.message || "Save failed. Please try again.");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Student Early Leave Requests</h2>
      </div>

      <div className="card">
        <div className="card-body">
          {/* <div className="col-md-2">
            <label className="form-label">
              Center<span className="text-danger fs-9">*</span>
            </label>
            <Controller
              name="centerId"
              control={control}
              rules={{ required: "This field is required." }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={centersData.map((center) => ({
                    value: center.id,
                    label: center.name,
                  }))}
                  isDisabled={savedCenterId !== "0"}
                  onChange={(selectedOption, actionMeta) => {
                    if (actionMeta.action === "clear") {
                      setValue("centerId", null);
                    } else {
                      setValue("centerId", selectedOption);
                      setSelectedCenterId(selectedOption.value);
                    }
                    trigger("centerId");
                  }}
                  className="react-select-style"
                  classNamePrefix="react-select-style-pref"
                  isClearable={!savedCenterId}
                />
              )}
            />
            {errors.centerId && (
              <small className="text-danger">{errors.centerId.message}</small>
            )}
          </div> */}

          <DataTable
            columns={columns}
            data={earlyLeaveRequestsData}
            pagination
            dense
            customStyles={customTableStyles}
            highlightOnHover={true}
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={setRowsPerPage}
          />
        </div>
      </div>
    </>
  );
}

export default EarlyLeaveRequest;
